/* eslint-disable */
import Vue from 'vue'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': false, 'button': false, 'navbar': false, 'title': false,
  'toolbar': false, 'tooltip': false, 'movable': false, 'zoomable': false, 'rotatable': false,
  'scalable': false, 'transition': false, 'fullscreen': false, 'keyboard': false, 'url': 'data-source' }
})
